"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react2 = require("@headlessui/react");
var _Icon = require("../Icon");
var _Text = require("../Text");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  base: "px-24 py-16 rounded-8 text-1 leading-1_5 border",
  container: "fixed z-40 justify-center top-8 left-8 right-8",
  topLeft: "s576:top-16 s576:left-16 s576:right-auto",
  topRight: "s576:top-16 s576:right-16 s576:left-auto",
  topCenter: "s576:left-1/2 s576:right-auto s576:-translate-x-1/2",
  box: "flex gap-x-8",
  info: {
    bgColor: "bg-gray-f4f5f7",
    iconColor: "text-gray-65657b",
    border: "border-gray-a9acc4"
  },
  error: {
    bgColor: "bg-red-fff6f6",
    iconColor: "text-red-c34648",
    border: "border-red-c34648"
  },
  warning: {
    bgColor: "bg-yellow-fcf5e6",
    iconColor: "text-yellow-bd8236",
    border: "border-yellow-bd8236"
  },
  success: {
    bgColor: "bg-green-e2fcf9",
    iconColor: "text-green-227c6c",
    border: "border-green-227c6c"
  },
  close: "text-gray-65657b cursor-pointer mt-4",
  animation: {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }
};
const Toast = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    open = true,
    showIcon = true,
    variant = "info",
    maxWidth = "max-w-2xl",
    position = "topCenter",
    delay = 5000,
    onClose,
    ...props
  } = _ref;
  (0, _react.useEffect)(() => {
    if (open && delay) {
      const timer = setTimeout(onClose, delay);
      return () => clearTimeout(timer);
    }
  }, [open, delay]);
  const icon = variant === "error" ? /*#__PURE__*/_react.default.createElement(_Icon.AlertCircle, {
    className: THEME.error.iconColor,
    "aria-hidden": "true"
  }) : variant === "success" ? /*#__PURE__*/_react.default.createElement(_Icon.CheckCircle2, {
    className: THEME.success.iconColor,
    "aria-hidden": "true"
  }) : variant === "warning" ? /*#__PURE__*/_react.default.createElement(_Icon.AlertTriangle, {
    className: THEME.warning.iconColor,
    "aria-hidden": "true"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Info, {
    className: THEME.info.iconColor,
    "aria-hidden": "true"
  });
  return /*#__PURE__*/_react.default.createElement(_react2.Transition.Root, {
    show: open,
    as: _react.Fragment
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: THEME.animation.enter,
    enterFrom: THEME.animation.enterFrom,
    enterTo: THEME.animation.enterTo,
    leave: THEME.animation.leave,
    leaveFrom: THEME.animation.leaveFrom,
    leaveTo: THEME.animation.leaveTo
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: (0, _classnames.default)(THEME.container, THEME[position]),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    role: "alert",
    className: (0, _classnames.default)(THEME.base, THEME[variant].bgColor, THEME[variant].border, maxWidth, className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: THEME.box
  }, showIcon ? icon : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1"
  }, typeof children === "string" ? /*#__PURE__*/_react.default.createElement(_Text.Text, null, children) : children), /*#__PURE__*/_react.default.createElement(_Icon.X, {
    className: THEME.close,
    size: 16,
    "aria-label": "Close",
    onClick: onClose
  }))))));
});
exports.Toast = Toast;
Toast.displayName = "Toast";